import { render, staticRenderFns } from "./MainBranchTable.vue?vue&type=template&id=055c9eaf&scoped=true"
import script from "./MainBranchTable.vue?vue&type=script&lang=js"
export * from "./MainBranchTable.vue?vue&type=script&lang=js"
import style0 from "./MainBranchTable.vue?vue&type=style&index=0&id=055c9eaf&prod&scoped=true&lang=css"
import style1 from "./MainBranchTable.vue?vue&type=style&index=1&id=055c9eaf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055c9eaf",
  null
  
)

export default component.exports